import { createReducer } from '@reduxjs/toolkit';
import { generateAICourse, setGeneratedAICreationData, setGeneratingCourse, setHasSeenAICourseSummaryModal, setSelectedCourse } from 'redux/actions/ai-course-creation';
import { initialRootState } from '.';

const pushOrUpdateAiCreationCommands = (state, action) => {
  const currentCourse = state.models.courses[state.app.currentCatalogId];
  const aiCreationCommand = currentCourse.aiCreationCommands
    .find(command => command.id === action.payload.id);
  if (aiCreationCommand) {
    aiCreationCommand.inProgress = action.payload.inProgress;
  } else {
    currentCourse.aiCreationCommands.push(action.payload);
  }
};

export default createReducer(initialRootState, builder => {
  builder
    .addCase(setSelectedCourse, (state, action) => {
      state.app.aiCourseCreation.selectedCourseId = action.payload;
    })
    .addCase(setGeneratingCourse, (state, action) => {
      state.models.courses[state.app.currentCatalogId].canGenerateAiCreationCommands = false;
      state.app.aiCourseCreation.isGenerating = action.payload;
    })
    .addCase(setGeneratedAICreationData, (state, action) => {
      pushOrUpdateAiCreationCommands(state, action);
    })
    .addCase(generateAICourse.fulfilled, (state, action) => {
      pushOrUpdateAiCreationCommands(state, action);
    })
    .addCase(setHasSeenAICourseSummaryModal, (state, action) => {
      const aiCreationCommand = state.models.courses[state.app.currentCatalogId].aiCreationCommands
        .find(command => command.id === action.payload.commandId);

      if (aiCreationCommand) {
        aiCreationCommand.requester.hasSeenCompletionModal = action.payload.value;
      }
    });
});

